<template>
  <div class="navbar">
    <div class="navbar-left">
      <el-button
        type="text"
        icon="el-icon-s-fold"
        class="collapse-btn"
        @click="toggleSidebar"
      />
      <span class="system-title">{{ $appTitle }}</span>
    </div>
    <div class="navbar-right">
      <notification-bell class="navbar-bell" />
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="user-info">
          <el-avatar :size="30" icon="el-icon-user-solid" />
          <span class="username">{{ username }}</span>
          <i class="el-icon-arrow-down el-icon--right" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="changePassword">
            <i class="el-icon-key" /> 修改密码
          </el-dropdown-item>
          <el-dropdown-item command="logout" divided>
            <i class="el-icon-switch-button" /> 退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- 修改密码 Dialog -->
    <el-dialog
      title="修改密码"
      :visible.sync="pwdDialogVisible"
      width="420px"
      :close-on-click-modal="false"
      @closed="handleDialogClosed"
    >
      <el-form
        ref="pwdForm"
        :model="pwdForm"
        :rules="pwdRules"
        label-width="88px"
      >
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input v-model="pwdForm.oldPassword" type="password" show-password placeholder="请输入当前密码" />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="pwdForm.newPassword" type="password" show-password placeholder="6-20 位，修改后需重新登录" />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="pwdForm.confirmPassword" type="password" show-password placeholder="请再次输入新密码" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="pwdDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleSubmitPwd">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { changePassword } from '@/api/auth'
import NotificationBell from '@/components/NotificationBell/index.vue'

const validateConfirm = function(rule, value, callback) {
  if (!value) {
    callback(new Error('请再次输入新密码'))
  } else if (value !== this.pwdForm.newPassword) {
    callback(new Error('两次输入的新密码不一致'))
  } else {
    callback()
  }
}

export default {
  name: 'Navbar',
  components: { NotificationBell },
  data() {
    return {
      pwdDialogVisible: false,
      submitting: false,
      pwdForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      pwdRules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度应在 6-20 位之间', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirm.bind(this), trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
    username() {
      return this.userInfo ? this.userInfo.name || this.userInfo.phone : '未知用户'
    }
  },
  methods: {
    ...mapActions('app', ['toggleSidebar']),
    handleCommand(command) {
      if (command === 'logout') {
        this.handleLogout()
      } else if (command === 'changePassword') {
        this.handleChangePassword()
      }
    },
    async handleLogout() {
      await this.$store.dispatch('user/logout')
      this.$router.push('/login')
      this.$message.success('已退出登录')
    },
    handleChangePassword() {
      this.pwdDialogVisible = true
    },
    handleDialogClosed() {
      if (this.$refs.pwdForm) this.$refs.pwdForm.resetFields()
      this.submitting = false
    },
    handleSubmitPwd() {
      this.$refs.pwdForm.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          await changePassword({
            oldPassword: this.pwdForm.oldPassword,
            newPassword: this.pwdForm.newPassword
          })
          this.$message.success('密码修改成功，请使用新密码重新登录')
          this.pwdDialogVisible = false
          // 密码变更后强制登出，避免新旧密码混用
          await this.$store.dispatch('user/logout')
          this.$router.push('/login')
        } catch (err) {
          this.$message.error((err && err.message) || '密码修改失败')
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style scoped>
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 100%;
}

.navbar-left {
  display: flex;
  align-items: center;
}

.collapse-btn {
  font-size: 20px;
  padding: 0;
  margin-right: 12px;
}

.system-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.navbar-right {
  display: flex;
  align-items: center;
}

.navbar-bell {
  margin-right: 20px;
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.username {
  margin-left: 8px;
  font-size: 14px;
  color: #303133;
}
</style>
